import { UserSearch as UserSearchComponent } from '@/components/UserSearch';

export default function UserSearch() {
  return (
    <div className="container mx-auto py-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-center">Find Users</h1>
        <UserSearchComponent />
      </div>
    </div>
  );
}